<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-list" class="q-mb-sm" /> {{ $t('faq_categories') }}
        </div>

        <div class="row gutter-sm q-mb-lg">
            <div class="col-xs-12 col-sm-12">
                <q-field :count="140">
                    <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                </q-field>
            </div>

             <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'admin_faq_categories' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'

export default {
    i18nOptions: { namespaces: ['common', 'faq', 'admin'] },

    data() {
        return {
            id: '',
            title: '',
            status:  1,
            statuses: [
                { label: this.$t('published'), value: 1 },
                { label: this.$t('unpublished'), value: 2 }
            ],
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },
    },

    methods: {
        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('status', this.status)

                if (this.id != 0) {
                    this.$axios.put(`/admin_faq/faq_categories/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('faq_category_edit_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'admin_faq_categories' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_faq/faq_categories/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('faq_category_add_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'admin_faq_categories' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/admin_faq/faq_categories/${this.id}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.status = response.data.status

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },
    },

    created() {
        this.id = this.$route.params.id
        if (this.id != 0) this.fetchData()
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(140) }
        }
    }
}
</script>

<style>

</style>
